'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Rekapi = require('rekapi/dist/rekapi');
var _factory = require('react-spark-scroll');

function factory(options) {
  return _factory(_extends({
    animator: {
      instance: function instance() {
        return new Rekapi(document.body);
      }
    }
  }, options));
}

module.exports = factory;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-spark-scroll-rekapi/lib/index.js
// module id = 267
// module chunks = 7